import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton: React.FC = () => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(true);
  const phoneNumber = '77019823126';
  const message = encodeURIComponent('Здравствуйте! Хотел(а) бы узнать подробнее о турах.');

  return (
    <div className="fixed bottom-24 lg:bottom-6 right-4 lg:right-6 z-40 flex items-end gap-3">
      {isTooltipVisible && (
        <div className="bg-white rounded-2xl shadow-2xl p-4 max-w-[240px] animate-fade-in relative hidden lg:block">
          <button
            onClick={() => setIsTooltipVisible(false)}
            className="absolute -top-2 -right-2 w-6 h-6 bg-neutral-200 rounded-full flex items-center justify-center hover:bg-neutral-300 transition-colors"
          >
            <X className="w-3 h-3" />
          </button>
          <p className="text-sm text-neutral-700 font-medium">
            Напишите нам в WhatsApp — ответим за 5 минут!
          </p>
        </div>
      )}
      <a
        href={`https://wa.me/${phoneNumber}?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        className="relative w-14 h-14 lg:w-16 lg:h-16 bg-green-500 rounded-full flex items-center justify-center shadow-2xl hover:bg-green-600 transition-all hover:scale-110 whatsapp-pulse"
      >
        <MessageCircle className="w-7 h-7 lg:w-8 lg:h-8 text-white relative z-10" />
      </a>
    </div>
  );
};

export default WhatsAppButton;
